import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	fileInput: {
		display: 'none',
	},
	label: {
		fontWeight: THEME.typography.fontWeights.semibold,
	},
});
